import {initVue} from '@/base/base';
import Common from "../common/common.vue";
import Main from './rating.vue';
initVue(Main,Common);
